import React from 'react';
import { toast } from 'react-toastify';
import { CloseButton } from 'h-commons';
import HiverIconToast from '../components/HiverIconToast';
/**
 * Dispatches action to show message
 * @param {Object} message Message object of format { type, message }
 */
function showMessage(messageObject) {
    const { message, type, autoClose } = messageObject;
    let toastId;
    if (type === 'success')
        toastId = toast.success(<HiverIconToast message={message} />, {
            closeButton: <CloseButton />,
            autoClose
        });
    else if (type === 'error')
        toastId = toast.error(<HiverIconToast message={message} />, {
            closeButton: <CloseButton />,
            autoClose
        });
    else if (type === 'info-dark') {
        toastId = toast.info(<HiverIconToast message={message} />, {
            closeButton: <CloseButton />,
            autoClose,
            className: "toast_dark"
        });
    }
    else
        toastId = toast.info(<HiverIconToast message={message} />, {
            closeButton: <CloseButton />,
            autoClose
        });

    return toastId;
}

function removeToast(toastId) {
    toast.dismiss(toastId);
}

export { showMessage, removeToast };